import script from "./BrushMapDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapDialog.vue?vue&type=style&index=0&id=1b92ed96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b92ed96"]])

export default __exports__